import axios from "@/api/config_php";
//用户列表
export const userLists = param => axios.post("/amp/api/v1/user/lists", param, { baseURL: "/api" });

//获取列表详情
export const userDetail = param => axios.get(`/amp/api/v1/user/detail?id=${param}`, { baseURL: "/api" });

//验证用户唯一
export const check_account_unique = param => axios.post("/amp/api/v1/user/check_account_unique", param, { baseURL: "/api" });

//添加用户
export const createUser = param => axios.post("/amp/api/v1/user/createUser", param, { baseURL: "/api" });

//更新用户
export const updateUser = param => axios.post("/amp/api/v1/user/updateUser", param, { baseURL: "/api" });

//删除用户
export const delUser = param => axios.post("/amp/api/v1/user/delUser", param, { baseURL: "/api" });

//锁定用户
export const lockUser = param => axios.post("/amp/api/v1/user/locking", param, { baseURL: "/api" });

//解锁用户
export const unlockUser = param => axios.post("/amp/api/v1/user/unlock", param, { baseURL: "/api" });
//操作日志
export const operatorLog = param => axios.post("/amp/api/v1/action_log/lists", param, { baseURL: "/api" });

//操作日志详情 action_log
export const actionLogDetail = param => axios.post("/amp/api/v1/action_log/detail", param, { baseURL: "/api" });
//获取个人信息
export const getPersonalInfo = param => axios.get("/amp/api/v1/user/getUserInfo");

//修改个人信息
export const modifyPersonalInfo = param => axios.post("/amp/api/v1/user/updateUserInfo", param);

//修改邮箱
export const modifyEmail = param => axios.post("/amp/api/v1/user/updateUserEmail", param);
//修改手机号
export const modifyMobileNumber = param => axios.post("/amp/api/v1/editPhoneStore", param);
//添加手机号
export const addMobileNumber = param => axios.post("/amp/api/v1/addPhoneStore", param);
// 验证短信验证码
export const authVeriChangePhoneCode = param => axios.post("/amp/api/v1/authVeriCodeTwo", param);

//验证手机号
export const checkMobileNumber = param => axios.post("/amp/api/v1/checkPhone", param);

//验证 账号是否已存在
export const inspectAccount = param => axios.post("/amp/api/v1/inspectAccount", param);

// 角色列表
export const getRoles = param => axios.get(`/amp/api/v1/platformRole/lists?client_company_id=${param}`);
// 全部角色权限
export const rolePerms = param => axios.get(`/amp/api/v1/platformRole/getPowerList`, { params: param });
// 根据角色获取权限
export const gePermsByRole = param => axios.get(`/amp/api/v1/platformRole/getrole`, { params: param });
// 添加角色
export const rolePermInsert = param => axios.post(`/amp/api/v1/platformRole/insert`, param);
// 编辑角色
export const rolePermUpdate = param => axios.post(`/amp/api/v1/platformRole/update`, param);
// 删除角色
export const rolePermDelete = param => axios.post(`/amp/api/v1/platformRole/del`, param);

// 用户列表
export const getUsers = param => axios.get(`/amp/api/v1/platformUser/lists`, { params: param });
// 添加用户
export const userInsert = param => axios.post(`/amp/api/v1/platformUser/insert`, param);
// 编辑用户
export const userUpdate = param => axios.post(`/amp/api/v1/platformUser/update`, param);
// 用户详情
export const getUserInfo = param => axios.get(`/amp/api/v1/platformUser/getUser`, { params: param });
// 删除用户
export const delUser_ = param => axios.post(`/amp/api/v1/platformUser/del`, param);

// 获取用户数据权限
export const getAuthority = param => axios.get(`/amp/api/v1/platformUser/getAuthority`, { params: param });
// 更新用户数据权限
export const setAuthority = param => axios.post(`/amp/api/v1/platformUser/setAuthority`, param);
// 获取用户权限配置
export const getAuthorityConfig = param => axios.get(`/amp/api/v1/platformUser/getAuthorityConfig`, { params: param });
// 设置用户数据权限配置
export const setAuthorityConfig = param => axios.post(`/amp/api/v1/platformUser/setAuthorityConfig`, param);
// 转换角色
export const transfere = param => axios.post(`/amp/api/v1/platformUser/transfer`, param);
// 获取所有已有权限
export const getAuthorityAll = param => axios.get(`/amp/api/v1/platformUser/getAuthorityAll`, { params: param });

// 删除用户数据权限
export const delAuthority = param => axios.post(`/amp/api/v1/platformUser/delAuthority`, param);

export const checkPhoneExists = param => axios.get(`/amp/api/v1/user/checkPhoneExists`);

// 更新协议知晓状态接口文档
export const updateAgreementAwareness = param => axios.post(`/amp/api/v1/platformUser/updateAgreementAwareness`, param);